/* Mobile category tabs (ported from the "sky" theme for Concept) */
if (!customElements.get('mobile-category-tabs')) {
  class MobileCategoryTabs extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('.mobile-category__nav');
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab)));
      this.nav?.addEventListener('keydown', (e) => this.onKeyDown(e));

      // Theme editor: show the tab when its block is selected in the sidebar
      this.addEventListener('shopify:block:select', (e) => {
        const tab = e.target.closest('[role="tab"]');
        if (tab) this.select(tab, false);
      });
    }

    select(tab, scroll = true) {
      if (!tab) return;

      this.tabs.forEach((t) => {
        const active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== tab.dataset.target;
      });

      if (scroll && this.nav) {
        const left = tab.offsetLeft - (this.nav.clientWidth - tab.offsetWidth) / 2;
        this.nav.scrollTo({ left, behavior: 'smooth' });
      }
    }

    onKeyDown(e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      let i = this.tabs.findIndex((t) => t.classList.contains('is-active'));
      i += e.key === 'ArrowRight' ? 1 : -1;
      if (i >= this.tabs.length) i = 0;
      if (i < 0) i = this.tabs.length - 1;
      this.tabs[i].focus();
      this.select(this.tabs[i]);
    }
  }

  customElements.define('mobile-category-tabs', MobileCategoryTabs);
}
